import { render } from "./EmployeeDetail.vue?vue&type=template&id=7ca5ba8c&scoped=true"
import script from "./EmployeeDetail.vue?vue&type=script&lang=js"
export * from "./EmployeeDetail.vue?vue&type=script&lang=js"

import "./EmployeeDetail.vue?vue&type=style&index=0&id=7ca5ba8c&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca5ba8c"]])

export default __exports__